import { render, staticRenderFns } from "./Expired.vue?vue&type=template&id=95df7bba&scoped=true&"
import script from "./Expired.vue?vue&type=script&lang=js&"
export * from "./Expired.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95df7bba",
  null
  
)

export default component.exports